import request from '@/utils/request'
import qs from 'qs'
import {getCookie} from '@/utils/cookiejs'

//获取起运国家
export function GetStartCountry() {
  return request({
    url: '/api/webapi/country/getStart',
    method: 'get'
  })
}

//获取目的国家
export function GetDestCountry() {
  return request({
    url: '/api/webapi/country/getDest',
    method: 'get'
  })
}

//城市检索
export function GetCityByCountry(data) {
  return request({
    url: `/api/WebAPI/Country/City/GetByCountry?keywords=${data.keyword}&countryId=${data.countryId}`,
    method: 'get'
  })
}

//机场/港口检索
export function GetPortByCountry(data) {
  return request({
    url: `/api/base/GetPortByCountry?keywords=${data.keyword}&countryId=${data.countryId}`,
    method: 'get'
  })
}

//机场/港口检索
export function GetFbaStore(data) {
  return request({
    url: `/api/base/FbaStoreaddress/GetAll?keywords=${data.keyword}&countryId=${data.countryId}`,
    method: 'get'
  })
}

//查价
export function QueryPrice(data) {
  return request({
    url: `/api/shipping/Calculation`,
    method: 'post',
	data:data,
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

//获取查价记录
export function GetLogList(calculationSource) {
  return request({
    url: `/api/shipping/Calculation/LogList?calculationSource=${calculationSource|0}`,
    method: 'get',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

//查价记录置顶
export function ToppingLog(data) {
  return request({
    url: `/api/shipping/Calculation/ToppingLog/${data.id}/${data.status}`,
    method: 'put',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

//删除查价记录
export function RemoveLog(id) {
  return request({
    url: `/api/shipping/Calculation/RemoveLog?id=${id}`,
    method: 'delete',
	headers: {
		'Authorization':getCookie('token')
	}
  })
}

